// ============================================
// ROLC OneROLC - History/Router
// Version: 3.6.0
// ============================================

let currentPath = '/';
let currentParams = {};
let listeners = [];

// ============================================
// Parse Hash
// ============================================
export function parseHash() {
    const hash = window.location.hash || '#/';
    const path = hash.replace('#', '');
    
    const [pathWithoutQuery, queryString] = path.split('?');
    const params = {};
    
    if (queryString) {
        const pairs = queryString.split('&');
        for (const pair of pairs) {
            const [key, value] = pair.split('=');
            if (key) {
                params[decodeURIComponent(key)] = value ? decodeURIComponent(value) : '';
            }
        }
    }
    
    return { path: pathWithoutQuery || '/', params };
}

// ============================================
// Navigate to a hash route
// ============================================
export function navigate(path, params = {}) {
    let hash = '#' + path;
    
    const queryParts = [];
    for (const [key, value] of Object.entries(params)) {
        if (value !== undefined && value !== null && value !== '') {
            queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
    }
    if (queryParts.length > 0) {
        hash += '?' + queryParts.join('&');
    }
    
    if (window.location.hash !== hash) {
        window.location.hash = hash;
    } else {
        handleHashChange();
    }
}

// ============================================
// Go back
// ============================================
export function goBack() {
    window.history.back();
}

// ============================================
// Get current route
// ============================================
export function getCurrentRoute() {
    return { path: currentPath, params: currentParams };
}

// ============================================
// Subscribe to route changes
// ============================================
export function subscribe(listener) {
    listeners.push(listener);
    return () => {
        const index = listeners.indexOf(listener);
        if (index > -1) listeners.splice(index, 1);
    };
}

// ============================================
// Handle hash change
// ============================================
function handleHashChange() {
    const { path, params } = parseHash();
    currentPath = path;
    currentParams = params;
    
    listeners.forEach(listener => {
        try {
            listener({ path, params });
        } catch (err) {
            console.error('Route listener error:', err);
        }
    });
}

// ============================================
// Initialize router
// ============================================
export function initRouter() {
    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    window.addEventListener('popstate', handleHashChange);
    return getCurrentRoute();
}


